export default "__VITE_ASSET__Di4WQv0u__"